import { useSelector } from "react-redux";
import { CLIENTS_CATEGORIES } from "../../../constants/globals";

const HeaderStep = ({
  first_name,
  second_name,
  last_name,
  stepNumber,
  stepName,
  stepText = "Step",
}) => {
  const { step1 } = useSelector((state) => state?.AddOrEditPartner);
  const { stepInfo: Step1Info } = step1;
  const currentClientCategory = CLIENTS_CATEGORIES.find(
    (c) => c.id == Step1Info?.client?.client_category_id ?? 0
  )?.name_en;

  return (
    <>
      <div className="card-header !tw-bg-primary tw-text-white d-flex tw-flex-col md:tw-flex-row tw-gap-2 align-items-center justify-content-between">
        {stepNumber && (
          <h4 className="card-title mb-0 tw-w-full md:tw-w-fit">
            {stepText} ({stepNumber}) : <span className="">{stepName}</span>
          </h4>
        )}
        <div className="tw-w-full md:tw-w-fit">
          {first_name && (
            <h5 className="card-title mb-0">
              Name:{" "}
              <span className="">
                {first_name + " " + second_name + " " + last_name}
              </span>
            </h5>
          )}
        </div>
      </div>
      <h5 className="card-title max-md:tw-text-sm tw-whitespace-nowrap mb-0 !tw-mt-2 tw-ps-5 tw-text-primary !tw-w-1/2">
        Client Category:{" "}
        {currentClientCategory && (
          <span className="">{currentClientCategory ?? "Unknown"}</span>
        )}
      </h5>
    </>
  );
};

export default HeaderStep;
